<template>
    <modal-base :pacifier="false">
        <template #title>Your Call is Scheduled</template>

        <template #subtitle>You will receive a call at the time you've select to be connected with your Unbundled Lawyer.</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            this.$store.commit('card');

            setTimeout(() => {
                this.$event.$emit('close-modal');
            }, 5000);
        }
    }
</script>
